import { render, staticRenderFns } from "./DrawerListItem.vue?vue&type=template&id=399841b8&scoped=true&"
import script from "./DrawerListItem.vue?vue&type=script&lang=ts&"
export * from "./DrawerListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DrawerListItem.vue?vue&type=style&index=0&id=399841b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399841b8",
  null
  
)

export default component.exports